













































































import { Component, ModelSync, Vue } from "vue-property-decorator";
import PlayerSlot from "@/classes/PlayerSlot";
import SlotTag from "@/types/SlotTag";
import SlotTagService from "@/classes/SlotTagService";

@Component({ name: "EventEditorSlotGroupPlayerSlot" })
export default class EventEditorSlotGroupPlayerSlot extends Vue {
  @ModelSync("playerSlotValue", "input")
  public readonly playerSlot!: PlayerSlot;

  public availableTags: SlotTag[] = [];
  public loadingTags = false;

  public validationRules = {
    playerSlotNameRules: [
      (value: string) => {
        if (value) { return true; }

        return "Slot name is required.";
      },
      (value: string) => {
        if (value.length <= 50) { return true; }

        return "Slot name must be 50 characters or less.";
      },
    ],
    playerSlotDescriptionRules: [
      (value: string) => {
        if (value) { return true; }

        return "Slot description is required.";
      },
      (value: string) => {
        if (value.length <= 150) { return true; }

        return "Slot description must be 150 characters or less.";
      },
    ],
  };

  public async mounted() {
    await this.loadTags();
  }

  public async loadTags() {
    try {
      this.loadingTags = true;
      this.availableTags = await SlotTagService.getAll();
    } catch (error) {
      this.$store.dispatch("showErrorSnackbar", "Failed to load slot tags.");
    } finally {
      this.loadingTags = false;
    }
  }

  public getTagColor(tagName: string): string {
    return SlotTagService.getTagColor(tagName);
  }

  public getTagIcon(tagName: string): string {
    return SlotTagService.getTagIcon(tagName);
  }
}
